import moment from "moment";

export const LOAD_MYTECHIE_REPORT         = "task/report/mytechie/load";
export const LOAD_MYTECHIE_REPORT_SUCCESS = "task/report/mytechie/load/success";
export const LOAD_MYTECHIE_REPORT_FAILURE = "task/report/mytechie/load/failure";

export const LOAD_LOGIN_BEHAVIOR_REPORT         = "task/report/loginBehavior/load";
export const LOAD_LOGIN_BEHAVIOR_REPORT_SUCCESS = "task/report/loginBehavior/load/success";
export const LOAD_LOGIN_BEHAVIOR_REPORT_FAILURE = "task/report/loginBehavior/load/failure";

export const EXPORT_LOGIN_BEHAVIOR_REPORT         = "task/report/loginBehavior/export";
export const EXPORT_LOGIN_BEHAVIOR_REPORT_SUCCESS = "task/report/loginBehavior/export/success";
export const EXPORT_LOGIN_BEHAVIOR_REPORT_FAILURE = "task/report/loginBehavior/export/failure";

export const loadMyTechieReport = ({ interval }, onSuccess) => {
  const [ fromDate, toDate ] = interval || [];
  if (!fromDate || !toDate) {
    return {
      type: LOAD_MYTECHIE_REPORT_FAILURE,
      result: {
        message: "Ungültiger Interval (von, bis)"
      }
    };
  }
  return {
    types: [
      LOAD_MYTECHIE_REPORT,
      LOAD_MYTECHIE_REPORT_SUCCESS,
      LOAD_MYTECHIE_REPORT_FAILURE,
    ],
    promise: (client) =>
      client.get(
        `/mytechie/download/reports?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`,
      ),
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    interval
  };
};


export function getDefaultReportInterval(interval) {
  const today = moment().startOf("day");
  const minPossibleDate = moment("20.04.2026", "DD.MM.YYYY");
  const minDate = moment.max(minPossibleDate, moment().subtract(2, "years"));
  
  let fromDate = minDate;
  let toDate = today;
  if (interval && interval.length === 2) {
    fromDate = moment(interval[0]);
    toDate = moment(interval[1]);
  }
  return [
    fromDate.format("YYYY-MM-DD"),
    toDate.format("YYYY-MM-DD"),
    [fromDate.toDate(), toDate.toDate()]
  ];
}

export const loadLoginBehaviorReport = (interval, onSuccess) => {
  const [fromDate, toDate, reportInterval] = getDefaultReportInterval(interval);
  console.log("Loading login behavior report with interval:", fromDate, "-", toDate);
  return {
    types: [
      LOAD_LOGIN_BEHAVIOR_REPORT,
      LOAD_LOGIN_BEHAVIOR_REPORT_SUCCESS,
      LOAD_LOGIN_BEHAVIOR_REPORT_FAILURE
    ],
    promise: (client) => client.get(`/companies/reports/employeeLoginReports/startDates/${encodeURIComponent(fromDate)}/endDates/${encodeURIComponent(toDate)}`),
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    reportInterval
  };
};

export const exportLoginBehaviorReport = (interval, onSuccess) => {
  const [fromDate, toDate] = getDefaultReportInterval(interval);
  return {
    types: [
      EXPORT_LOGIN_BEHAVIOR_REPORT,
      EXPORT_LOGIN_BEHAVIOR_REPORT_SUCCESS,
      EXPORT_LOGIN_BEHAVIOR_REPORT_FAILURE
    ],
    promise: (client) => client.get(`/companies/reports/employeeLoginReports/export/csv/startDates/${encodeURIComponent(fromDate)}/endDates/${encodeURIComponent(toDate)}`),
    onSuccess: () => {
      onSuccess && onSuccess();
    },
  };
};
